import { logisticsTenant, type UserProfile } from './loginSlice';

const getSubDomain = (host: string) => host.split(':')[0].split('.')[0];

export enum Environment {
    RIO = 'RIO',
    VW_RIO_DEV = 'VW_RIO_DEV',
    VW_PROD = 'VW_PROD',
    VW_QA = 'VW_QA',
}
export const getEnvironmentBySubDomain = (): Environment => {
    const subDomain = getSubDomain(window.location.host);
    switch (subDomain) {
        case 'vw-rio-dev':
            return Environment.VW_RIO_DEV;
        case 'vw-qa':
            return Environment.VW_QA;
        case 'vw-prod':
            return Environment.VW_PROD;
        case 'transport-execution':
        case 'localhost':
        case '127':
            return Environment.RIO;
        default:
            throw Error(`Environment could not be extracted for ${window.location.host}`);
    }
};

export const getEnvironmentByUser = (user: UserProfile): Environment => {
    if (user.logisticsTenant === logisticsTenant.VW_QA) {
        return Environment.VW_QA;
    } else if (user.logisticsTenant === logisticsTenant.VW_PROD) {
        return Environment.VW_PROD;
    } else if (user.logisticsTenant === logisticsTenant.VW_RIO_DEV) {
        return Environment.VW_RIO_DEV;
    } else if (user.logisticsTenant == null && user.tenant != null) {
        return Environment.RIO;
    } else {
        throw Error(`Environment could not be extracted for ${user.tenant} ${user.logisticsTenant}`);
    }
};
